<template>
  <div>
   <div class="tabBox">
      <span
        class="item"
        v-for="(item,index) in navList"
        :key="index"
        :class="{'item_active':isShowTab === index}"
        @click="changeTab(index)"
      >{{item}}</span>
    </div>
    <div class="tabItemContet taskWrap" v-if="isShowTab==0">
      <van-list
        ref="vanList"
        v-model="loading"
        :finished="finished"
        :finished-text='finishedText'
        @load="onLoad"
        class="wrapper"
        >

        <div v-for="(item,index) in  dataAallList" :key="index" @click="toPageDetail(item)">
          <div class="total" v-if="item.status==11">
            <div class="total_top">{{item.taskName}}</div>
            <div class="total_mid">
              <span class="title">工单</span>
              <span class="number">{{item.total}}个</span>
              <span class="title">已完成</span>
              <span class="number">{{item.finishedTotal}}个</span>
              <span class="title">进度</span>
              <span class="number">{{item.descore}}%</span>
            </div>
            <div class="total_foot">
              <!-- <van-progress :percentage='item.descore' color="#dddddd" stroke-width="8" /> -->
              <percentLine
                :pBageText="item.finishedTotal"
                :pPercent="item.descore/100"
                :pUnit="pUnit"
              ></percentLine>
            </div>
          </div>
          <div class="total" v-if="item.status!=11">
            <div class="total_top">{{item.taskName}}</div>
            <div class="total_mid_1">
              <div class="div_ul">
                <van-tag
                  type="primary"
                  class="div_tag line_border_btn"
                  v-for="(i,idx) in item.industryCategory"
                  :key="idx"
                >{{i}}</van-tag>
              </div>
              <div class="div_ul_total">
                共
                <span class="div_ul_spa">{{item.total}}</span>个工单
              </div>
            </div>
            <div class="total_foot_1">
              <ul class="total_foot_ul">
                <li class="total_foot_li">受委托⽅：<span>{{item.unitName}}</span></li>
                <li class="total_foot_li" v-show='item.createTime'>创建时间：<span>{{item.createTime |filtTime}}</span></li>
                <li class="total_foot_li" v-show='item.updateTime'>完成时间：<span>{{item.updateTime |filtTime}}</span></li>
              </ul>
              <div class="total_foot_div"
                :class="{
                orange_text : item.statusName=='待审核'|item.statusName=='待审核',
                green_text :item.statusName=='评分完成',
                close_text: item.statusName=='已关闭'
                }">{{item.statusName}}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="tabItemContet taskWrap" v-if="isShowTab==1">
      <van-list
        ref="vanList"
        v-model="loadingCenter"
        :finished="finishedCenter"
        :finished-text='finishedText'
        @load="onLoadCenter"
        class="wrapper"
        >
        <div
          class="total"
          v-for="(item,index) in actionList"
          :key="index"
          @click="toPageDetail(item)"
          >
          <div class="total_top">{{item.taskName}}</div>
          <div class="total_mid">
              <span class="title">工单</span>
              <span class="number">{{item.total}}个</span>
              <span class="title">已完成</span>
              <span class="number">{{item.finishedTotal}}个</span>
              <span class="title">进度</span>
              <span class="number">{{item.descore}}%</span>
          </div>
          <div class="total_foot">
            <!-- <van-progress :percentage='item.finishedTotal/item.descore' color="#dddddd" stroke-width="8" /> -->
            <percentLine
              :pBageText="item.finishedTotal"
              :pPercent="item.descore/100"
              :pUnit="pUnit"
            ></percentLine>
          </div>
        </div>
      </van-list>
    </div>
      <div class="tabItemContet taskWrap" v-if="isShowTab==2">
        <van-list
        ref="vanList"
        v-model="loadingRight"
        :finished="finishedRight"
        :finished-text='finishedText'
        @load="onLoadRight"
        class="wrapper"
        >
          <div
              class="total"
              v-for="(item,index) in finishedList"
              :key="index"
              @click="toPageDetail(item)"
              >
              <div class="total_top">{{item.taskName}}</div>
              <div class="total_mid_1">
                <div class="div_ul">
                  <van-tag
                    type="primary"
                    class="div_tag line_border_btn"
                    v-for="(i,idx) in item.industryCategory"
                    :key="idx"
                  >{{i}}</van-tag>
                </div>
                <div class="div_ul_total">
                  共
                  <span class="div_ul_spa">{{item.total}}</span>个工单
                </div>
              </div>
              <div class="total_foot_1">
                <ul class="total_foot_ul">
                  <li class="total_foot_li">受委托⽅：<span>{{item.unitName}}</span></li>
                  <li class="total_foot_li" v-show='item.createTime'>创建时间：<span>{{item.createTime |filtTime}}</span></li>
                  <li class="total_foot_li" v-show='item.updateTime'>完成时间：<span>{{item.updateTime |filtTime}}</span></li>
                </ul>
                <div class="total_foot_div"
                  :class="{
                    orange_text : item.statusName=='待审核'|item.statusName=='待审核',
                    green_text :item.statusName=='评分完成',
                    close_text: item.statusName=='已关闭'
                    }">{{item.statusName}}</div>
              </div>
            </div>
        </van-list>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity';
    import percentLine from '../../components/PercentLine';

    export default {
        components: {
            percentLine
        },
        data () {
            return {
                pUnit: '个',
                loading: false,
                finished: false,
                finishedText: '',
                pageIndex: 1,
                pageSize: 10,

                loadingCenter: false,
                finishedCenter: false,
                pageIndexCenter: 1,
                isShowTab: 0,

                loadingRight: false,
                finishedRight: false,
                pageIndexRight: 1,

                navList: ['全部', '进行中', '已结束'],
                active: this.$route.query.progresIndex,
                dataAallList: [], // 全部数据
                actionList: [], // 进行中数据
                finishedList: [], // 已完成数据
                auditStatus: '' // 跳转至其他页面的值
            };
        },
        created () {
            this.gettaskPageAll();
            this.gettaskPageAction();
            this.gettaskPageFinished();
        },
        watch: {
            $route () {
                this.active = this.$route.query.progresIndex
            }
        },
        methods: {
            changeTab (index) {
                this.isShowTab = index
                this.pageIndex = 1
            },
            onLoadRight () {
                this.pageIndexRight++
                this.gettaskPageFinished()
            },
            onLoadCenter () {
                this.pageIndexCenter++
                this.gettaskPageAction()
            },
            onLoad () {
                this.pageIndex++
                this.gettaskPageAll()
            },
            // 跳转至任务详情页面
            toPageDetail (item) {
                let parm = {
                    taskId: item.id
                };
                api.taskInfo(parm).then(res => {
                    if (res.ret === 0) {
                        this.auditStatus = res.data.auditStatus;
                        if (this.auditStatus == 0) {
                            this.$router.push({
                                path: '/integrity/toAudited',
                                query: {
                                    id: res.data.id,
                                    taskId: res.data.id
                                }
                            });
                        } else if (this.auditStatus == 1) {
                            this.$router.push({
                                path: '/integrity/auditPass',
                                query: {
                                    id: res.data.id,
                                    taskId: res.data.id
                                }
                            });
                        } else if (this.auditStatus == 2) {
                            this.$router.push({
                                path: '/integrity/auditFailed',
                                query: {
                                    id: res.data.id,
                                    taskId: res.data.id
                                }
                            });
                        }
                    }
                });
            },
            gettaskPageAll () {
                let parm = {
                    status: '',
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                };
                api.taskPage(parm).then(res => {
                    if (res.ret === 0) {
                        for (let i in res.data.list) {
                            res.data.list[i].descore = Math.floor(((res.data.list[i].finishedTotal * 1) / res.data.list[i].total) * 1 * 100) * 1;
                        }
                        let arr = res.data.list
                        if (arr.length > 0) {
                            this.dataAallList = this.dataAallList.concat(arr)
                            this.finished = false
                        } else {
                            this.finished = true
                            this.finishedText = '没有更多了'
                        }
                        this.loading = false
                        // this.dataAallList = res.data.list;
                    }
                });
            },
            // 进行中
            gettaskPageAction () {
                let parm = {
                    status: '1',
                    pageIndex: this.pageIndexCenter,
                    pageSize: this.pageSize
                };
                api.taskPage(parm).then(res => {
                    // console.log(res)
                    if (res.ret === 0) {
                        for (let i in res.data.list) {
                            res.data.list[i].descore =
                                Math.floor(
                                    ((res.data.list[i].finishedTotal * 1) /
                                        res.data.list[i].total) *
                                        1 *
                                        100
                                ) * 1;
                        }
                        let brr = res.data.list
                        if (brr.length > 0) {
                            this.actionList = this.actionList.concat(brr)
                            this.finishedCenter = false
                        } else {
                            this.finishedCenter = true
                            this.finishedText = '没有更多了'
                        }
                        this.loadingCenter = false
                        // this.actionList = res.data.list;
                    }
                });
            },
            // 已完成
            gettaskPageFinished () {
                let parm = {
                    status: '2',
                    pageIndex: this.pageIndexRight,
                    pageSize: this.pageSize
                };
                api.taskPage(parm).then(res => {
                    // console.log(res)
                    if (res.ret === 0) {
                        let crr = res.data.list
                        if (crr.length > 0) {
                            this.finishedList = this.finishedList.concat(crr)
                            this.finishedRight = false
                        } else {
                            this.finishedRight = true
                            this.finishedText = '没有更多了'
                        }
                        this.loadingRight = false
                        // this.finishedList = res.data.list;
                    }
                });
            }
        },
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    };
</script>
<style lang="less" scoped>

    .tabBox {
      white-space: nowrap;
      // height: 54px;
      display: flex;
      line-height: 46px;
      width: 100%;
      padding: 16px 15px 2px 16px;
      background: #FBFBFB;

      .item {
        display: inline-block;
        height: 22px;
        line-height: 22px;
        margin-right: 24px;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
      }
      .item_active {
        border-bottom: 2px solid @base-color;
        color: @base-color;
        padding-bottom: 1px;
        font-weight: bold;
      }
    }

.taskWrap{
  background:#FBFBFB;
  border: 1px solid #FBFBFB;
  padding-bottom: 20px;
  height: 100%;

  .tabs {
    margin-bottom: 10px;
  }
  .total {
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-top: 10px;
    margin: 10px 12px 10px 12px;
    padding:16px;
    .total_top {
      font-size: 14px;
      font-weight:600;
      color:#333333;
      margin-bottom: 8px;
    }
    .total_mid {
      line-height: 20px;
      font-size: 12px;
      margin-bottom: 3px;
      color: #666666;
      .title{
        color: #666666;
        margin-right: 4px;
      }
      .number {
        color: #333;
        margin-right: 24px;
      }
    }
    .total_mid_1 {
      overflow: hidden;
      margin-bottom: 10px;
      .div_ul {
        float: left;
        .div_tag {
          margin-right: 8px;
          margin-left: -3px;
        }
      }
      .div_ul_total {
        float: left;
        line-height: 17px;
        font-size:12px;
        font-weight:400;
        color:rgba(153,153,153,1);
        .div_ul_spa {
          color: #333;
        }
      }
    }
    .total_foot_1 {
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .total_foot_ul {
        float: left;
        width: 70%;
        .total_foot_li {
          font-size:14px;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span{
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
          }
        }
      }
      .total_foot_div {
        color: #666;
        float: left;
        width: 30%;
        font-size:14px;
        line-height: 20px;
        text-align: right;
      }
      .orange_text{
        color:rgba(255,140,25,1);
      }
      .green_text{
        color:#36B374;
      }
      .close_text{
        color: #999999;
      }
    }
  }
}
</style>
<style  lang="less">
.taskWrap{
   .van-tabs__line {
      position: absolute;
      bottom: 0.4rem;
      left: 0;
      z-index: 1;
      height: 0.08rem;
      background-color: #36b374;
      border-radius: 0.08rem;
    }
    .van-tag--primary{
      background-color: #fff;
      color: #36B374;
      // border: 0.6px solid #36B374;
      height: 12px;
      margin-bottom: 4px;
      transform: scale(0.85);
    }
    .van-progress{
      background: rgba(229, 245, 237, 1);
    }
    .van-progress__portion{
      background: #36B374 !important;
    }
    .van-progress__pivot{
     background: rgba(54, 54, 54, 1)!important;
    }
    .van-progress__pivot{
      top: -35px;
      border-radius:3px;
      padding: 8px 10px;
      font-size: 14px;
      font-weight: bold;
      &::after{
          position:absolute;
          bottom: -6px;
          right:16px;
          content:" "; // content 不要漏了，漏了会显示不出来
          width:0px;
          height:0px;
          border-right:7px solid transparent;
          border-top:7px solid rgba(54, 54, 54, 1);
          border-left:7px solid transparent;
        }
    }

    .van-progress{
      border-radius: 0;
    }

}

</style>
